import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=3bf0824e&"
import script from "./Zone.vue?vue&type=script&lang=js&"
export * from "./Zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports